module.exports = __webpack_public_path__ + "img/安卓.309ad709.png";